import trainingService from '../../services/training.service';
import workSheetService from '../../services/workSheet.service';

import { mixins } from '../../mixins';

export default {
    namespaced: true,
    state: {
        trainingList: [],
        training: {},
        trainingListOptions: [],
        trainingListByOnlyTraining: [],
        createdTrainingList: [],
        selectedUserForTrainingSummary: {},
        selectedTrainingForUserSummary: {},
        commentsForSelectedWorkSheet: [],
        allTemplate:[],
        userInEvaluation:null,
        trainingForEvaluation:null,
        templateLabels:null,
        evaluationScore:[]
    },
    getters: {
        getTrainingList: (state) => state.trainingList,
        getTraining: (state) => state.training,
        getTotalTrainingCount: (state) => state.totalTraining,
        getTrainingListOptions(state) {
            return state.createdTrainingList.map((training) => {
                return {
                    value: training.id,
                    label: training.name,
                };
            });
        },
        getTrainingListByOnlyTraining: (state) => state.trainingListByOnlyTraining,
        getCreatedTrainingList: (state) => state.createdTrainingList,
        getSelectedUserForTrainingSummary: (state) => state.selectedUserForTrainingSummary,
        getSelectedTrainingForUserSummary: (state) => state.selectedTrainingForUserSummary,
        getCommentsForSelectedWorkSheet: (state) => state.commentsForSelectedWorkSheet,
        getCommentsForSelectedWorkSheetInChat: (state, context, rootState) => {
            return state.commentsForSelectedWorkSheet.map((comment) => {
                return {
                    type: 'text',
                    author: rootState.Auth.user.userId !== comment.userId ? 'them' : 'me',
                    data: { text: comment.comment, meta: comment.userName + ' - ' + mixins.formatDate(comment.date) },
                };
            });
        },
        getAllTemplate(state){
            return state.allTemplate
        },
        getUserInEvaluation(state){
            return state.userInEvaluation
        },
        getTrainingForEvaluation(state){
            return state.trainingForEvaluation
        },
        getTemplateLabels(state){
            return state.templateLabels
        },
        getEvaluationScore(state){
            return state.evaluationScore
        }
    },
    mutations: {
        setTrainingList(state, payload) {
            state.trainingList = payload;
        },
        setTrainingListOptions(state, payload) {
            state.trainingListOptions = payload;
        },
        setTraining(state, payload) {
            state.training = payload;
        },
        setTrainingListByOnlyTraining(state, payload) {
            state.trainingListByOnlyTraining = payload;
        },
        setCreatedTrainingList(state, payload) {
            state.createdTrainingList = payload;
        },
        setSelectedUserForTrainingSummary(state, payload) {
            state.selectedUserForTrainingSummary = payload;
        },
        setSelectedTrainingForUserSummary(state, payload) {
            state.selectedTrainingForUserSummary = payload;
        },
        setSelectedWorkSheetComments(state, payload) {
            state.commentsForSelectedWorkSheet = payload;
        },
        setAllTemplate(state,payload){
            state.allTemplate=payload
        },
        setUserInEvaluation(state,payload){
            state.userInEvaluation=payload
        },
        setTrainingForEvaluation(state,payload){
            state.trainingForEvaluation=payload
        },
        setTemplateLabel(state,payload){
            state.templateLabels=payload
        },
        setEvaluationScore(state,payload){
            state.evaluationScore = payload
        }
    },
    actions: {
        GET_TRAINING_LIST({ commit, rootState }, { categoryPage = 1, trainingSize = 4, categorySize = 10 }) {
            trainingService.getTrainingList(
                {
                    params: {
                        categoryPage,
                        trainingSize,
                        categorySize,
                        userId: rootState.Auth.user.userId,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setTrainingList', data.data.listings);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                    },
                }
            );
        },
        GET_TRAINING_LIST_BY_ONLY_TRAINING({ commit, rootState }, { name = '', size = 20, page = 1 }) {
            trainingService.getTrainingListOnlyTraining(
                {
                    params: {
                        name,
                        size,
                        page,
                        userId: rootState.Auth.user.userId,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setTrainingListByOnlyTraining', data.data.trainings);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                    },
                }
            );
        },
        GET_TRAINING_LIST_OPTIONS({ commit }, { name = '', size = 20, page = 1 }) {
            trainingService.getTrainingListOptions(
                {
                    params: {
                        name,
                        size,
                        page,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setTrainingListOptions', data.data.content);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                        // errorCallback(error);
                    },
                }
            );
        },
        GET_CREATED_TRAINING_LIST({ commit }, { userId, name = '', size = 20, page = 1 }) {
            trainingService.getCreatedTrainingList(
                userId,
                {
                    params: {
                        name,
                        size,
                        page,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setCreatedTrainingList', data.data.content);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                        // errorCallback(error);
                    },
                }
            );
        },

        GET_USERS_FOR_ENROLLED_TRAINING({ commit }, { id, size = 10, page = 1, name = '', status = '' }) {
            trainingService.getUsersForEnrolledTraining(
                id,
                {
                    params: {
                        size,
                        page,
                        name,
                        status,
                    },
                },
                {
                    success: ({ data }) => {
                        if (data.status === 'OK') {
                            commit('setSelectedTrainingForUserSummary', data.data);
                        } else {
                            commit('setSelectedTrainingForUserSummary', {});
                        }
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                    },
                }
            );
        },
        GET_COMMENTS_BY_WORKSHEET_ID({ commit }, id) {
            workSheetService.getCommentsByWorksheetId(id, {
                success: ({ data }) => {
                    if (data.status === 'OK') {
                        commit('setSelectedWorkSheetComments', data.data.comments);
                    } else {
                        commit('setSelectedWorkSheetComments', []);
                    }
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                },
            });
        },
        GET_WORKSHEETS_BY_USER_ID({ commit }, { userId, size = 6, page = 1, name = '', status = '' }) {
            workSheetService.getworkSheetByUserId(
                userId,
                {
                    params: {
                        size,
                        page,
                        name,
                        status,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setSelectedUserForTrainingSummary', data.data);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                        // errorCallback(error);
                    },
                }
            );
        },
        GET_TRAINING_LIST_BY_CATEGORY({ commit, state, rootState }, { categoryId, page = 1, size = 4 }) {
            trainingService.getTrainingListByPagination(
                {
                    params: {
                        categoryId,
                        page,
                        size,
                        userId: rootState.Auth.user.userId,
                    },
                },
                {
                    success: ({ data }) => {
                        if (state.trainingList.length > 0) {
                            const trainingList = state.trainingList;

                            const training = trainingList.find((item) => item.categoryId === categoryId);

                            if (training) {
                                training.trainings = [...training.trainings, ...data.data.trainings];
                                commit('setTrainingList', trainingList);
                            }
                        } else {
                            commit('setTrainingList', data.data.listings);
                        }
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                        // errorCallback(error);
                    },
                }
            );
        },

        CREATE_TRAINING(context, { payload, successCallback, errorCallback }) {
            trainingService.createTraining(payload, {
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        GET_TRAINING_BY_ID({ commit }, id) {
            trainingService.getTrainingById(id, {
                success: ({ data }) => {
                    commit('setTraining', data.data);
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                    // errorCallback(error);
                },
            });
        },
        ENROLL_TRAINING(context, { payload, successCallback, errorCallback }) {
            trainingService.enrollTraining(payload, {
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        BULK_ASSIGN_TRAINING(context, { payload, successCallback, errorCallback }) {
            trainingService.bulkAssignTraining(payload, {
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        CREATE_TEMPLATE(context,{payload,successCallback, errorCallback }){
            trainingService.createTemplate(payload,{
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            })
        },
        GET_ALL_TEMPLATE({commit},{name=''}){
            trainingService.getAllTemplate(
                {
                    params:{
                        name
                    }
                },
                {
                    success: (res) => {
                        let structuredTemplate=[]
                        res.data.data.map((temp)=>{
                            structuredTemplate.push({label:temp.name,value:temp.id})
                        })
                        commit('setTemplateLabel',structuredTemplate)
                        commit('setAllTemplate',res.data.data)
                    },
                    error: (err) => {
                        console.log(err)
                    },
                })
        },
        SET_USER_IN_EVALUATION({commit},{payload}){
            // console.log(payload)
            commit('setUserInEvaluation',payload)
        },
        SET_TRAINING_FOR_EVALUATION({commit},{payload}){
            commit('setTrainingForEvaluation',payload)
          },
        SET_TEMPLATE_DATA(context,{payload,adminId,successCallback,errorCallback}){
            // console.log(payload)
            trainingService.setTemplateData(adminId,payload,{
                success: (res) => {
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            })
        },
        GET_EVALUATION_SCORE({commit},{payload,adminId}){
            // console.log(payload)
            trainingService.getEvaluationScore(adminId,{
                params:{
                    userId:payload.userId,
                    trainingId:payload.trainingId
                }
            },
            {
                success:(res) =>{
                    commit('setEvaluationScore',res.data.data)
                },
                error:(err)=>{
                    console.log(err)
                }
            }
            )
        }
    },
};
